import { ListPlus, Sparkles, X } from 'lucide-react';

interface Props {
  count: number;
  onMakeSequence: () => void;
  onMakeKeywords: () => void;
  onClear: () => void;
}

/**
 * Phase 14.1 多选浮动 ActionBar。
 *
 * 当 LogList 内 Shift/Cmd+Click 多选了 N 行后，在视口底部固定一条工具条，
 * 引导用户把这些行打包成规则。
 */
export function MultiSelectActionBar({
  count,
  onMakeSequence,
  onMakeKeywords,
  onClear,
}: Props): JSX.Element {
  return (
    <div
      className="pointer-events-auto fixed left-1/2 bottom-6 z-30 flex -translate-x-1/2 items-center gap-2 rounded-full border border-line bg-bg-card px-3 py-1.5 text-[11px] text-ink shadow-2xl"
      role="toolbar"
      aria-label="多选行的批量动作"
    >
      <span className="font-mono tabular-nums text-sky-300">已选 {count} 行</span>
      <span className="h-3 w-px bg-line" />
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md border border-amber-500/50 bg-amber-500/10 px-2 py-1 text-amber-200 hover:bg-amber-500/20"
        onClick={onMakeSequence}
        title="把所选行按序构造成 sequence 规则"
      >
        <ListPlus className="h-3 w-3" />
        合并为序列规则
      </button>
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md border border-emerald-500/50 bg-emerald-500/10 px-2 py-1 text-emerald-200 hover:bg-emerald-500/20"
        onClick={onMakeKeywords}
        title="把每行单独做成一条 keyword 规则，全部塞进同一套件"
      >
        <Sparkles className="h-3 w-3" />
        每行一条关键字
      </button>
      <span className="h-3 w-px bg-line" />
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-ink-muted hover:bg-bg-soft hover:text-ink"
        onClick={onClear}
        title="清除多选"
      >
        <X className="h-3 w-3" />
        清除
      </button>
    </div>
  );
}
